import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { audioContext } from '../../webAudio/audioContext';
import { lastLoopStart } from './lastLoopStart';

const mapStateToChordProgressProps = ({
   activeInterface: {
      referencePlaying,
      compareAnswer,
      tempo,
      referenceTempo,
      beatCount,
   },
}) => ({
   playing: !compareAnswer && referencePlaying,
   beatDuration: 60 / (referencePlaying ? referenceTempo : tempo),
   beatCount,
});

const Progress = connect(mapStateToChordProgressProps)(
   ({ playing, beatDuration, beatCount }) => {
      const [progress, setProgress] = useState(null);

      useEffect(() => {
         let shouldAnimate = true;
         let nextFrameId;
         const animate = () => {
            const now = audioContext.currentTime;
            const loopStarted =
               now >= lastLoopStart.currentScheduledTime
                  ? lastLoopStart.currentScheduledTime
                  : lastLoopStart.previousScheduledTime;

            const newProgress =
               ((now - loopStarted) / (beatDuration * beatCount)) * 100;

            if (loopStarted != null) {
               setProgress(newProgress);
            } else {
               setProgress(null);
            }

            if (playing && shouldAnimate) {
               nextFrameId = requestAnimationFrame(animate);
            }
         };
         if (playing) {
            animate();
         } else {
            setProgress(null);
         }
         return () => {
            cancelAnimationFrame(nextFrameId);
            shouldAnimate = false;
         };
      }, [playing, beatDuration, beatCount]);

      return (
         <svg width="100%" viewBox="0 0 100 5" preserveAspectRatio="none">
            <rect x="0" y="0" width={progress} height="5" fill="currentColor" />
         </svg>
      );
   }
);

const SequencerProgress = () => (
   <div className="sequencer-progress">
      <Progress />
   </div>
);

export { SequencerProgress };
